"use client";
import { useState, useEffect, useContext } from "react";
import { CornerDownRight, Heart } from "lucide-react";
import { FaHeart } from "react-icons/fa";
import { WishlistContext } from "@/context/WishlistContext";
import { Button } from "@/components/ui/button";
import Link from "next/link";

const AddWishlist = ({ product }) => {
  const { wishlist, toggleWishlist } = useContext(WishlistContext);
  const [wishlistProducts, setWishlistProducts] = useState([]);

  useEffect(() => {
    setWishlistProducts(wishlist);
  }, [wishlist]);

  const isInWishlist = wishlistProducts.some(
    (item) => item?._id === product?._id
  );

  return (
    <>
      {isInWishlist ? (
        <div
          variant="outline"
          className="flex items-center gap-1 cursor-pointer"
        >
          <CornerDownRight size={15} className="text-blue-500" />
          <Link href="/wishlist" className="text-blue-500 font-medium text-sm">
            View wishlist
          </Link>
        </div>
      ) : (
        <div
          onClick={() => toggleWishlist(product)}
          className="group flex items-center gap-1 cursor-pointer text-gray-500"
        >
          <Heart size={16} className="group-hover:text-blue-500" />
          <p className="group-hover:text-blue-500">Add to wishlist</p>
        </div>
      )}
    </>
  );
};

export default AddWishlist;
